export class Home365Utils {

  public static sortAlphabetically(arr: any[], direction: 'ASC'|'DSC' = 'ASC', key: string = '') {
    if (!arr || arr.length == 0) return [];
    return arr.sort((a: any, b: any) => {
      const nameA = key ? a[key].toUpperCase() : a.toUpperCase();
      const nameB = key ? b[key].toUpperCase() : b.toUpperCase();
      if (nameA < nameB) {
        return direction === 'ASC' ? -1 : 1;
      }
      if (nameA > nameB) {
        return direction === 'ASC' ? 1 : -1;
      }
      return 0;
    })
  }

  public static sortNumerically(arr: any, direction: 'ASC'|'DSC' = 'ASC', key: string = '') {
    if (!arr || arr.length == 0) return [];
    return arr.sort((a: any, b: any) => direction === 'ASC' ? a[key]-b[key] : b[key]-a[key])
  }
  public static readonly isArrEmpty = (arr: unknown[] | undefined | null) => {
    if (!arr) {
      return true;
    }
    return !Home365Utils.isArrNotEmpty(arr);
  }
  public static readonly isArrNotEmpty: (arr: unknown[] | undefined | null) => boolean = (arr): arr is unknown[] => {
    return (!!arr && arr[0] !== null && arr[0] !== undefined);
  }
  public static readonly getFixedNumber = (num: number, digits: number) => {
    return Number(num.toFixed(digits));
  }
  public static readonly numberHasValue = (num: number) => {
    return !!num || num === 0;
  }
  static readonly StringToNumber = (str: string | number) => {
    if (typeof str === 'number') {
      return str;
    }
    const regex = new RegExp(/\d+|\.+/g);
    const newStr = str?.match(regex)?.join('') ?? null;
    if (newStr) {
      return Number(newStr) ?? 0;
    }
    return null;
    // return newStr ? Number(newStr) : null;
  }
  static readonly CopyObject: <T>(obj: T) => T = (obj: unknown) => JSON.parse(JSON.stringify(obj));
}
